import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { Button } from "react-bootstrap";
import {
    plansList,
    getTaxgsts,
    resetplansList,
    deletePlans,
} from "../../reducers/commonReducer";
import { home } from "../../const";
import PlansUpdate from "./PlansUpdates";


const Plans = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();


    useEffect(() => {
        if (!localStorage.getItem("x-auth-token")) {
            navigate(home);
        }

        dispatch(getTaxgsts());
    }, [dispatch, navigate]);

    useEffect(() => {
        let timeOut = setTimeout(() => {
            dispatch(resetplansList());
            dispatch(plansList({}));
        }, 800);

        return () => clearTimeout(timeOut);
    }, []);

    const { plansListData, getTaxgstsData } = useSelector(
        (state) => state.commonReducer
    );

    return (
        <>
            <SideMenu />
            <div className="mt-extra content container-fluid">
                <table className="table mt-4 table-scrolling">
                    <thead className="normalplace">
                        <tr>
                            <th className="over-col-size text-center">Sr No.</th>
                            <th className="over-col-size">Name</th>
                            {/* <th className="over-col-size">SKU</th> */}
                            <th className="over-col-size">Slug</th>
                            <th className="over-col-size">Description</th>
                        
                            <th className="over-col-size">Service</th>
                            <th className="over-col-size">Sale Price</th>
                            <th className="over-col-size">MRP</th>
                            <th className="over-col-size">Tax Class</th>
                            {/* <th className="over-col-size">Avg. Rating</th> */}
                            <th className="over-col-size">Time Period</th>
                            <th className="over-col-size">Hot Selling</th>
                            <th className="over-col-size">Status</th>
                            <th className="over-col-size text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!!plansListData &&
                            plansListData.map((data, index) => {
                                const taxClass = getTaxgstsData?.list.find(
                                    (tax) => tax.id === data?.tax_class
                                );

                                return (
                                    <tr key={index}>
                                        <td>{index + 1}.</td>
                                        <td>{data?.name}</td>
                                        {/* <td>{data?.sku}</td> */}
                                        <td>{data?.slug}</td>
                                        <td>{data?.description}</td>
                                      
                                        <td>{data?.service?.shortName ? data?.service?.shortName : data?.service?.name}</td>
                                        <td>{data?.sale}</td>
                                        <td>{data?.mrp}</td>
                                        <td>{taxClass ? taxClass.name : "Unknown"}</td>
                                        {/* <td>{data?.avg?.rating || "N/A"}</td> */}
                                        <td>{data?.timeperiod}</td>
                                        <td>
                                            <b>
                                                {data?.hotSelling ? (
                                                    <span className="text-success">Active</span>
                                                ) : (
                                                    <span className="text-danger">Inactive</span>
                                                )}
                                            </b>
                                        </td>
                                        <td>
                                            <b>
                                                {data?.status ? (
                                                    <span className="text-success">Active</span>
                                                ) : (
                                                    <span className="text-danger">Inactive</span>
                                                )}
                                            </b>
                                        </td>

                                        <td>
                                            <Button
                                                className="m-1"
                                                variant="danger"
                                                onClick={async () => {
                                                    await dispatch(deletePlans(data?.id));
                                                    dispatch(plansList());
                                                }}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </Button>

                                            <PlansUpdate
                                                pname={data?.name}
                                                pdescription={data?.description}
                                                pmrp={data?.mrp}
                                                psale={data?.sale}
                                                ptax_class={data?.tax_class}
                                                ptimeperiod={data?.timeperiod}
                                                id={data?.id}
                                                pstatus={data?.status}
                                                pservice={data?.service}
                                                pbenefits={data?.benefits}
                                            />

                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default Plans;




